module.exports = __webpack_public_path__ + "img/mob4.8eacf535.png";